import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualStudentPerformance from "./routes/IndividualStudentPerformance";
export default store => {
  return {
    path: "student",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "student" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualStudentPerformance(store)],
  };
};
